export default __webpack_public_path__ + "static/media/do-1.6d44bc37.jpg";